import { getCurrentGruserSlice } from './grusers';
export const getPrivileges = (state, gruser)=>getCurrentGruserSlice(state, gruser).privileges;
export const canAddModule = (state, gruser)=>{
    var _getPrivileges;
    return ((_getPrivileges = getPrivileges(state, gruser)) === null || _getPrivileges === void 0 ? void 0 : _getPrivileges.addModule) === true;
};
export const canMoveModule = (state, gruser)=>{
    var _getPrivileges;
    return ((_getPrivileges = getPrivileges(state, gruser)) === null || _getPrivileges === void 0 ? void 0 : _getPrivileges.moveModule) === true;
};
export const canViewPage = (state, gruser)=>{
    var _getPrivileges;
    return ((_getPrivileges = getPrivileges(state, gruser)) === null || _getPrivileges === void 0 ? void 0 : _getPrivileges.viewPage) === true;
};
